export default "__VITE_ASSET__Dl6S3AEe__"